
export const CardStyles = {
  layout: {
    margin: '10 5',
    padding: '10 0',
  },
};